import React from 'react'
import { useMedia } from 'presentation/utils/window-media'
import SheetModalNew from 'presentation/shared/components/SheetModalNew'
import Modal from 'presentation/shared/components/Modal'
import ButtonNew from 'presentation/shared/components/ButtonNew'
import HeadingNew from 'presentation/shared/components/HeadingNew'
import * as S from './styles'
import DividerNew from '../DividerNew'

export type ResponsiveModalProps = {
  isOpen: boolean
  onClose: () => void
  onConfirm?: () => void
  title: string
  children: (isMobile: boolean) => React.ReactNode
  confirmButtonLabel?: string
  confirmButtonType?: 'button' | 'submit'
  cancelButtonLabel?: string
  disableConfirmButton?: boolean
  hideCancelButton?: boolean
  hideConfirmButton?: boolean
  width?: number
}

const ResponsiveModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  children,
  confirmButtonLabel = 'Confirmar',
  cancelButtonLabel = 'Cancelar',
  disableConfirmButton = false,
  hideCancelButton = false,
  hideConfirmButton = false,
  width = 800,
  confirmButtonType = 'submit'
}: ResponsiveModalProps) => {
  const media = useMedia()
  const isMobile = !media.md

  const content = children(isMobile)

  const primaryButton = (
    <ButtonNew
      size="large"
      onClick={onConfirm}
      disabled={disableConfirmButton}
      style={{ fontSize: '14px' }}
      type={confirmButtonType}
    >
      {confirmButtonLabel}
    </ButtonNew>
  )

  const secondaryButton = (
    <ButtonNew
      size="large"
      outlined
      onClick={onClose}
      style={{ fontSize: '14px' }}
      type="button"
    >
      {cancelButtonLabel}
    </ButtonNew>
  )

  if (media.md) {
    return (
      <Modal
        show={isOpen}
        close={onClose}
        preventAutomateClose
        noBackdrop={false}
        radius="16px"
        style={{
          width: `${width}px`
        }}
      >
        <S.ModalContent>
          <S.Header>
            <HeadingNew weight="bold" size="small" color="textSecondary">
              {title}
            </HeadingNew>
            <S.CloseIcon onClick={onClose} />
          </S.Header>
          <DividerNew height="2px" color="neutral100" />

          {content}

          {(!hideCancelButton || !hideConfirmButton) && (
            <S.ButtonGroup>
              {!hideCancelButton && secondaryButton}
              {!hideConfirmButton && primaryButton}
            </S.ButtonGroup>
          )}
        </S.ModalContent>
      </Modal>
    )
  }

  return (
    <SheetModalNew
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size="auto"
      backdrop="true"
      primaryButton={hideConfirmButton ? undefined : primaryButton}
      secondaryButton={hideCancelButton ? undefined : secondaryButton}
    >
      {content}
    </SheetModalNew>
  )
}

export default ResponsiveModal
